export default __webpack_public_path__ + "static/media/Albert Howard.0c207a66.png";